'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { setSentryUser, clearSentryUser, setSentryTag, clearSentryTag } from '@/modules/sentry/sentry.utils';
import type { User } from '@/modules/tenant';
type SentryUserProviderProps = {
  user?: User;
};

/**
 * 👤 User-level Sentry context registry
 * Sets user context for error tracking
 * Only clears user context on unmount (isolation)
 */
export default function SentryUserContext(t0) {
  const $ = _c(3);
  const {
    user
  } = t0;
  let t1;
  let t2;
  if ($[0] !== user) {
    t1 = () => {
      if (user) {
        setSentryUser({
          id: user.id,
          email: user.email,
          username: user.name
        });
        setSentryTag("user_id", user.id);
      }
      return () => {
        if (user) {
          clearSentryUser();
          clearSentryTag("user_id");
        }
      };
    };
    t2 = [user];
    $[0] = user;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}